import { render, staticRenderFns } from "./Dashboardbk.vue?vue&type=template&id=536ef433&scoped=true&"
import script from "./Dashboardbk.vue?vue&type=script&lang=js&"
export * from "./Dashboardbk.vue?vue&type=script&lang=js&"
import style0 from "./Dashboardbk.vue?vue&type=style&index=0&id=536ef433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ef433",
  null
  
)

export default component.exports